import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';
import * as yup from 'yup';

const config =  {
    name: 'payment-types',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'create' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' }
    ],
    endpoints: {
        paymentTypes: '/payment-types',
        paymentType: '/payment-types/[id]'
    },
    defaults: {
        createPaymentType: {
            name: "",
            description: "",
            type: "",
            handler: "",
            position: 0,
            active: false
        }
    },
    validations: {
        paymentType: yup.object().shape({
            name: yup.string().required("Numele este obligatoriu"),
            description: yup.string().required("Descrierea este obligatorie"),
            type: yup.string().required("Tipul este obligatoriu"),
            handler: yup.string(),
            position: yup.string(),
            active: yup.boolean()
        })
    }
}

const Config ={
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;